// Body-scoped Alpine data for header scroll behaviour. The navigation
// overlay's state lives on Alpine.store('nav') so it can survive Astro view
// transitions alongside the persisted overlay element — see
// src/scripts/nav-store.js.
import { pickIconInk, pickInk, sampleSurface } from './surface-contrast.js';

export default () => ({
    lastScroll: 0,
    scrollDelta: 0,
    atTop: true,

    // Colour of whatever the navigation toggle is currently sitting over, or
    // null over a backdrop that can't be read — see scripts/surface-contrast.js.
    navSurface: null,

    // Open, both belong to the navigation and take the brand green; closed,
    // they belong to the page behind them. The label needs to be readable
    // wherever it lands, while the hamburger gives up its green only where that
    // green would be lost.
    get navLabelInk() {
        if (this.$store.nav.open) return 'text-primary';

        return pickInk(this.navSurface) === 'white' ? 'text-white' : 'text-brand-black';
    },

    get navIconInk() {
        if (this.$store.nav.open) return 'text-primary';

        return pickIconInk(this.navSurface) === 'white' ? 'text-white' : 'text-primary';
    },

    _scrollHandler: null,
    _resizeHandler: null,
    _inkFrame: null,

    init() {
        this.lastScroll = window.scrollY;
        this.atTop = window.scrollY <= 100;
        this._scrollHandler = this.handleScroll.bind(this);
        this._resizeHandler = this.sampleNavInk.bind(this);
        window.addEventListener('scroll', this._scrollHandler);
        // Section boundaries move under the label when the layout reflows.
        window.addEventListener('resize', this._resizeHandler);
        this.sampleNavInk();
    },

    destroy() {
        if (this._scrollHandler) {
            window.removeEventListener('scroll', this._scrollHandler);
            this._scrollHandler = null;
        }

        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
            this._resizeHandler = null;
        }

        if (this._inkFrame) {
            cancelAnimationFrame(this._inkFrame);
            this._inkFrame = null;
        }
    },

    handleScroll() {
        const currentScroll = window.scrollY;

        // Accumulate scroll delta in the current direction
        const direction = currentScroll > this.lastScroll ? 1 : -1;
        const lastDirection = this.scrollDelta > 0 ? 1 : -1;

        if (direction === lastDirection) {
            this.scrollDelta += currentScroll - this.lastScroll;
        } else {
            this.scrollDelta = currentScroll - this.lastScroll;
        }

        this.atTop = currentScroll <= 100;
        this.lastScroll = currentScroll;
        this.sampleNavInk();
    },

    // Hit testing and reading computed styles are both layout-bound, so this is
    // held to one sample per frame however often scroll fires.
    sampleNavInk() {
        if (this._inkFrame) return;

        this._inkFrame = requestAnimationFrame(() => {
            this._inkFrame = null;

            const surface = sampleSurface(document.querySelector('[data-nav-label]'));

            // Most frames land on the same section, and reassigning would rerun
            // every binding that reads it.
            if (String(surface) !== String(this.navSurface)) {
                this.navSurface = surface;
            }
        });
    },
});
